<template>
	<Layout :loading="loading" :pageTitle="'Slides'">
		<template #cta>
			<router-link tag="a" :to="`${$route.path}/create`" class="btn btn-primary">Crear slide</router-link>
		</template>
		<template #bar>
			<div class="filters-box justify-content-between">
				<div class="filter">
					<div class="filter-input">
						<i class="icon icon-search"></i>
						<input
							type="text"
							class="form-control"
							placeholder="Buscar en slides"
							v-model="filters.search"
							@keyup.enter="updateFilters($event)"
						/>
						<div
							class="btn btn-light btn-clear-filter"
							v-if="filters.search"
							@click="
								filters.search = null
								updateFilters()
							"
						>
							<i class="icon icon-close"></i>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div class="container-fluid">
			<div class="card mt-2">
				<div class="card-body">
					<table class="table table-clickeable">
						<tr class="table-head">
							<td>Slide</td>
							<td></td>
						</tr>

						<router-link tag="tr" :to="`${$route.path}/${item.id}`" v-for="item of list" :key="item.id">
							<td>
								<div class="d-flex align-items-center">
									<span
										class="thumb thumb-xl"
										v-if="item.image"
										:style="`background-image:url(${item.image.urlThumb})`"
									></span>
									<div class="tc">
										<span v-html="item.formattedTitle"></span>
										<span class="text-secondary">{{ item.link }}</span>
									</div>
								</div>
							</td>
							<td class="text-right"></td>
						</router-link>
					</table>

					<div class="alert alert-light text-center mt-5" v-if="list.length == 0">
						No se han encontrado slides
					</div>

					<Pagination :pageData="pagination" @pageChange="pageChange" />
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"

export default {
	name: "MainSliders",
	data() {
		return {
			list: [],
			loading: false
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							mainSliders(take: $take, skip: $skip, search: $search) {
								data {
									id
									formattedTitle
									link
									image {
										urlThumb
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "no-cache"
				})
				.then((data) => {
					this.list = data.data.mainSliders.data.map((item) => {
						return { ...item, loading: false }
					})
					this.pagination.pageInfo = data.data.mainSliders.pageInfo
					this.loading = false
				})
		},

		deletePrompt(item) {
			this.$dialog
				.confirm(
					{
						title: "Eliminar slides",
						body: `¿Está seguro que desea eliminar el slide <strong>"${item.title}"</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.delete(item)
				})
		},

		delete(item) {
			item.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							mainSliderDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: item.id
					}
				})
				.then(() => {
					this.$toast.success("Elemento eliminado correctamente")
					this.load()
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					item.loading = false
				})
		}
	}
}
</script>

<style></style>
